import { useDateFormatPreference } from '@/hooks/useDateFormatPreference';

/**
 * Mounts the user's date format preference globally so non-React helpers
 * (sorting, formatting) read the right value. Renders nothing.
 */
export function DateFormatLoader() {
  useDateFormatPreference();
  return null;
}
